import React from 'react';
import './App.css'; // Custom CSS for styling

const App = () => {
  // Function to request a demo
  const requestDemo = () => {
    alert('Demo request submitted. We will contact you soon!');
  };

  // Function to handle Razorpay payment
  const handlePayment = () => {
    const options = {
      key: "rzp_test_P4pyj19ipc0vja", // Replace with your Razorpay API key
      amount: 50000, // Amount in paise (e.g., 50000 paise = ₹500)
      currency: "INR",
      name: "AI Innovate",
      description: "Test Transaction",
      image: "https://your-company-logo-url.com/logo.png", // Replace with your logo URL
      handler: function (response) {
        alert(`Payment Successful! Payment ID: ${response.razorpay_payment_id}`);
      },
      prefill: {
        name: "Customer Name",
        email: "customer@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  };

  // Function to scroll the solution grid
  const scrollGrid = (direction) => {
    const grid = document.querySelector('.solution-grid');
    const scrollAmount = grid.offsetWidth * 0.8; // Adjust the scroll amount as needed
    if (direction === 'left') {
      grid.scrollLeft -= scrollAmount;
    } else if (direction === 'right') {
      grid.scrollLeft += scrollAmount;
    }
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="navbar">
          <div className="logo">AI Innovate</div>
          <nav>
            <a href="#solutions">Solutions</a>
            <a href="#about">About Us</a>
            <a href="#contact">Contact</a>
            <button className="demo-btn" onClick={requestDemo}>
              Request Demo
            </button>
          </nav>
        </div>
        <div className="hero">
          <h1>Revolutionizing the Future with Generative AI</h1>
          <p>
            Explore cutting-edge AI tools to drive growth and efficiency. Watch
            our capabilities in action and step into the future.
          </p>
          <button className="learn-more-btn">Learn More</button>
        </div>
      </header>

      <section id="solutions" className="solutions">
        <h2>Our Solutions</h2>
        <div className="scroll-indicators">
          <button className="scroll-left" onClick={() => scrollGrid('left')}>
            &lt;
          </button>
          <div className="solution-grid">
            <div className="solution-tile">
              <h3>AI Content Generator</h3>
              <p>
                Create high-quality content in seconds tailored to your brand and
                audience.
              </p>
              <video controls>
                <source src="ai_content_generator_video.mp4" type="video/mp4" />
              </video>
            </div>
            <div className="divider"></div>
            <div className="solution-tile">
              <h3>AI-Powered Analytics</h3>
              <p>
                Turn complex data into actionable insights with our intelligent
                analytics tools.
              </p>
              <video controls>
                <source src="ai_analytics_video.mp4" type="video/mp4" />
              </video>
            </div>
            <div className="divider"></div>
            <div className="solution-tile">
              <h3>Virtual Assistant</h3>
              <p>
                Enhance customer experience with intelligent, 24/7 responsive
                virtual assistants.
              </p>
              <video controls>
                <source src="virtual_assistant_video.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <button className="scroll-right" onClick={() => scrollGrid('right')}>
            &gt;
          </button>
        </div>
      </section>

      <section id="demo" className="demo-section">
        <h2>Request a Demo</h2>
        <form className="demo-form" onSubmit={(e) => e.preventDefault()}>
          <input type="text" placeholder="Name" required />
          <input type="email" placeholder="Email" required />
          <input type="text" placeholder="Company Name" required />
          <textarea placeholder="Tell us about your requirements"></textarea>
          <button type="submit" onClick={requestDemo}>
            Submit
          </button>
        </form>
      </section>

      <section id="payment" className="payment-section">
        <h2>Make a Payment</h2>
        <p>
          Use Razorpay to subscribe to our services or make a one-time payment.
        </p>
        <button className="payment-btn" onClick={handlePayment}>
          Pay Now
        </button>
      </section>

      <footer className="app-footer">
        <p>
          &copy; 2024 AI Innovate. All rights reserved. |{' '}
          <a href="#privacy">Privacy Policy</a>
        </p>
      </footer>
    </div>
  );
};

export default App;